import { render, staticRenderFns } from "./ResearchInnovationReviewCouncil.vue?vue&type=template&id=0ee03988&"
import script from "./ResearchInnovationReviewCouncil.vue?vue&type=script&lang=js&"
export * from "./ResearchInnovationReviewCouncil.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInnovationReviewCouncil.vue?vue&type=style&index=0&id=0ee03988&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports